module.exports = __webpack_public_path__ + "static/img/viper.46f95e54.png";